import React, { Component } from "react";
import { connect } from "react-redux";
import {
    fetchTransactions as fetch,
    resetTransactions as reset,
    setTransactionsPagination as setPagination
} from "../../actions/transactions";

class TableTransaction extends Component {
    constructor(props) {
        super(props);
        this.handleChange = this.handleChange.bind(this);
        this.handleClick = this.handleClick.bind(this);
    }

    handleChange(e) {
        e.preventDefault();
        const { value } = e.target;
        const payload = {
            page: 1,
            perPage: parseInt(value)
        };
        this.props.setPagination(payload);
        this.props.fetch();
    }

    handleClick = page => e => {
        e.preventDefault();
        const payload = {
            page: parseInt(page)
        };
        this.props.setPagination(payload);
        this.props.fetch();
    };

    componentWillMount() {
        this.props.fetch();
    }

    componentWillUnmount() {
        this.props.reset();
    }

    render() {
        const {
            count,
            rows,
            pagination: { page, perPage, start, end }
        } = this.props.transactions;
        const moment = require("moment");
        return (
            <div className="" id="riwayat-transaksi">
                <div className="header">
                    <div className="row">
                        <div className="col-xs-6">
                            {/* <input type="text" placeholder="Search" className="form-search" onChange={ e => console.log(e) }/> */}
                        </div>
                        <div className="col-xs-6 text-right">
                            <label htmlFor="">
                                {
                                    this.props.lang[this.props.lang.locales]
                                        .misc.table.page
                                }
                                <select
                                    defaultValue={perPage}
                                    onChange={this.handleChange}
                                >
                                    <option value="25"> 25 </option>
                                    <option value="50"> 50 </option>
                                    <option value="100"> 100 </option>
                                    <option value="200"> 200 </option>
                                </select>
                            </label>
                        </div>
                    </div>
                </div>
                <table width="100%" className="table">
                    <thead>
                        <tr>
                            <th>
                                {
                                    this.props.lang[this.props.lang.locales]
                                        .contents.transaction.table.hotelName
                                }
                            </th>
                            <th>
                                {
                                    this.props.lang[this.props.lang.locales]
                                        .contents.transaction.table.city
                                }
                            </th>
                            <th>
                                {
                                    this.props.lang[this.props.lang.locales]
                                        .contents.transaction.table.country
                                }
                            </th>
                            <th>
                                {
                                    this.props.lang[this.props.lang.locales]
                                        .contents.transaction.table.bookingDate
                                }
                            </th>
                            <th>
                                {
                                    this.props.lang[this.props.lang.locales]
                                        .contents.transaction.table.checkIn
                                }
                            </th>
                            <th>
                                {
                                    this.props.lang[this.props.lang.locales]
                                        .contents.transaction.table.checkOut
                                }
                            </th>
                            <th>
                                {
                                    this.props.lang[this.props.lang.locales]
                                        .contents.transaction.table.room
                                }
                            </th>
                            <th>
                                {
                                    this.props.lang[this.props.lang.locales]
                                        .contents.transaction.table.night
                                }
                            </th>
                            <th>
                                {
                                    this.props.lang[this.props.lang.locales]
                                        .contents.transaction.table.points
                                }
                            </th>
                            <th>
                                {
                                    this.props.lang[this.props.lang.locales]
                                        .contents.transaction.table.source
                                }
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {rows.map(
                            (
                                {
                                    HotelName,
                                    City,
                                    Country,
                                    BookingDate,
                                    CheckIn,
                                    CheckOut,
                                    Room,
                                    Night,
                                    Points,
                                    Source
                                },
                                i
                            ) => (
                                <tr key={i}>
                                    <td>{HotelName}</td>
                                    <td>{City}</td>
                                    <td>{Country}</td>
                                    <td>
                                        {moment(BookingDate).format(
                                            "DD MMM YYYY"
                                        )}
                                    </td>
                                    <td>
                                        {moment(CheckIn).format("DD MMM YYYY")}
                                    </td>
                                    <td>
                                        {moment(CheckOut).format("DD MMM YYYY")}
                                    </td>
                                    <td>{Room}</td>
                                    <td>{Night}</td>
                                    <td>{Points}</td>
                                    <td>
                                        {Source === "POWERSUITE"
                                            ? "MG BEDBANK"
                                            : Source === "MIGRATION"
                                            ? ""
                                            : Source}
                                    </td>
                                </tr>
                            )
                        )}
                    </tbody>
                </table>
                {count > 0 && (
                    <div className="footer">
                        <div className="row">
                            <div className="col-xs-6">
                                <div
                                    className="showing"
                                    dangerouslySetInnerHTML={{
                                        __html: this.props.lang[
                                            this.props.lang.locales
                                        ].misc.table.show
                                            .replace("{start}", start)
                                            .replace("{end}", end)
                                            .replace("{count}", count)
                                    }}
                                />
                            </div>
                            <div className="col-xs-6">
                                <nav aria-label="Page navigation">
                                    <ul className="pagination">
                                        <li>
                                            <a
                                                href="#/"
                                                aria-label="Previous"
                                                onClick={this.handleClick(
                                                    page === 1 ? page : page - 1
                                                )}
                                            >
                                                <i className="glyphicon glyphicon-menu-left" />
                                                {
                                                    this.props.lang[
                                                        this.props.lang.locales
                                                    ].misc.table.previous
                                                }
                                            </a>
                                        </li>
                                        <li>
                                            <a
                                                href="#/"
                                                aria-label="Next"
                                                onClick={this.handleClick(
                                                    [0, page].includes(
                                                        Math.ceil(
                                                            count / perPage
                                                        )
                                                    )
                                                        ? page
                                                        : page + 1
                                                )}
                                            >
                                                {
                                                    this.props.lang[
                                                        this.props.lang.locales
                                                    ].misc.table.next
                                                }
                                                <i className="glyphicon glyphicon-menu-right" />
                                            </a>
                                        </li>
                                    </ul>
                                </nav>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        transactions: state.transactions,
        lang: state.lang
    };
};

const mapDispatchToProps = (dispatch, ownProp) => {
    return {
        fetch: () => dispatch(fetch()),
        reset: () => dispatch(reset()),
        setPagination: payload => dispatch(setPagination(payload))
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(TableTransaction);
